<template>
  <div class="colofon-social">
    <colofon-social-link href="http://app.nos.nl/op3/noordzee">
      <img class="social-img" src="../assets/img/icons/copy.svg">
    </colofon-social-link>
    <colofon-social-icon
      :target="true"
      href="https://www.facebook.com/share.php?u=http://app.nos.nl/op3/noordzee">
      <img class="social-img" src="../assets/img/icons/facebook.svg">
    </colofon-social-icon>
    <colofon-social-icon
      :target="true"
      href="https://twitter.com/intent/tweet?text=Herrie achter de horizon. Ervaar het effect van onze herrie onder water.&url=http://app.nos.nl/op3/noordzee">
      <img class="social-img" src="../assets/img/icons/twitter.svg">
    </colofon-social-icon>
    <colofon-social-icon href="mailto:?subject=Herrie achter de horizon.&body=http://app.nos.nl/op3/noordzee">
      <img class="social-img" src="../assets/img/icons/mail.svg">
    </colofon-social-icon>
  </div>
</template>
<script>
import ColofonSocialLink from './ColofonSocialLink'
import ColofonSocialIcon from './ColofonSocialIcon'

export default {
  components: {
    ColofonSocialLink,
    ColofonSocialIcon
  }
}
</script>
<style lang="scss" scoped>

  .colofon-social {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 70px 0;
  }

  .social-img {
    width: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/components/ColofonSocial.vue